const comments = [
  {
    name: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20woman%2C%20warm%20friendly%20expression%2C%20soft%20natural%20lighting%2C%20clean%20white%20background%2C%20modern%20casual%20style%2C%20high%20quality%20headshot%20photography&width=80&height=80&seq=avatar-01-user&orientation=squarish',
    drama: '长安十二时辰之风起云涌',
    text: '追了三季了，这一季的制作水准又上了一个台阶。服化道精细到每个细节，剧情节奏把控得恰到好处，每一帧都是壁纸级别的画面。强烈推荐！',
    rating: 5,
    time: '2天前',
  },
  {
    name: '剧荒拯救者',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20man%20in%20his%2030s%2C%20friendly%20smile%2C%20soft%20studio%20lighting%2C%20clean%20neutral%20background%2C%20modern%20casual%20attire%2C%20high%20quality%20portrait%20photography&width=80&height=80&seq=avatar-02-user&orientation=squarish',
    drama: '暗夜追光',
    text: '好久没看到这么硬核的国产悬疑剧了！逻辑严密、反转精彩，演员全员演技在线。一口气刷完 12 集根本停不下来，年度最佳预定。',
    rating: 5,
    time: '5天前',
  },
  {
    name: '暖阳浅浅',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20woman%20with%20warm%20smile%2C%20soft%20natural%20makeup%2C%20gentle%20studio%20lighting%2C%20clean%20white%20background%2C%20friendly%20approachable%20look%2C%20high%20quality%20portrait%20photography&width=80&height=80&seq=avatar-03-user&orientation=squarish',
    drama: '锦瑟年华',
    text: '看完哭了好几次，每个角色都有自己的命运和选择。那种年代特有的质感拍得太真实了，父母辈的故事让人感慨万千。准备二刷。',
    rating: 4,
    time: '1周前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-[1024px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">观众热评</h2>
          <p className="text-sm text-foreground-500">来自追剧伙伴的真实分享</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-100 rounded-2xl p-5 md:p-6 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex-shrink-0 rounded-full overflow-hidden bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-bold text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
              </div>
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-xs ${i < comment.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                  ></i>
                ))}
              </div>
              <p className="text-xs text-foreground-500 mb-3">
                在看《{comment.drama}》
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed">
                {comment.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}